module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30094",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4919",
      "atom": "static-1.5276",
      "conversations-error-reporting": "static-1.9087",
      "conversations-internal-pub-sub": "static-1.16182",
      "conversations-internal-schema": "static-1.13253",
      "conversations-message-history": "static-1.13312",
      "conversations-test-sdk": "static-1.10701",
      "conversations-visitor-experience-components": "static-1.23457",
      "data-fetching-client": "static-1.9857",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5792",
      "hs-test-utils": "static-1.8223",
      "hubspot-dlb": "static-2.1854",
      "HubStyleTokens": "static-2.11674",
      "I18n": "static-7.1649",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.3221",
      "jasmine-runner": "static-1.6654",
      "quartz": "static-1.7294",
      "react-dlb": "static-1.83",
      "react-select-plus": "static-1.108",
      "react-transition-group": "static-2.68",
      "redux-thunk": "static-2.43",
      "reselect": "static-3.8",
      "sanitize": "static-1.4677",
      "StyleGuideUI": "static-3.491",
      "transmute": "static-2.85",
      "urlinator": "static-1.4732",
      "usage-tracker": "static-1.7550",
      "usage-tracker-core": "static-1.7400",
      "usage-tracker-public": "static-1.7361",
      "viral-links-lib": "static-1.7270",
      "visitor-ui-component-library": "static-1.6342",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5015",
      "conversations-prop-types": "static-1.7653",
      "conversations-visitor-message-history": "static-1.22194",
      "cssUtils": "static-1.849",
      "enviro": "static-4.455",
      "flux-actions": "static-1.354",
      "foundations-components": "static-1.8305",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6417",
      "hubspot-url-utils": "static-1.4132",
      "immutable": "static-2.79",
      "metrics-js": "static-1.9637",
      "PatternValidationJS": "static-1-add-latest-to-version-tag.2",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "react": "static-7.189",
      "react-aria": "static-1.69",
      "react-dom": "static-7.85",
      "react-redux": "static-7.71",
      "react-rhumb": "static-1.16903",
      "react-utils": "static-2.5480",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "sanitize-text": "static-1.8346",
      "signup-constants": "static-1.19367",
      "styled-components": "static-2.89",
      "usage-tracker-multi": "static-1.5964",
      "visitor-ui-component-library-icons": "static-1.6153",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3538",
      "moment": "static-3.26",
      "quartz-config": "static-1.1072",
      "quartz-core": "static-1.6513",
      "foundations-assets": "static-1.5075",
      "foundations-theming": "static-1.4638",
      "UIComponents": "static-3.8620",
      "conversations-async-data": "static-2.7866",
      "customer-data-email": "static-1.18386",
      "cv-backend-services": "static-1.1589",
      "immutable-less": "static-1.4850",
      "conversations-skeleton-state": "static-1.7447",
      "crm-events-viz-core": "static-1.33775",
      "customer-data-objects": "static-1.7880",
      "icons": "static-2.667",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.756",
      "rpc-client-utils": "static-1.4858",
      "ui-images": "static-2.1211",
      "apollo-stack-hubspot": "static-3.89",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.85",
      "HeadJS": "static-2.780",
      "framer-motion": "static-1.75",
      "hs-test-utils-bend-plugin": "static-1.3334",
      "msw": "static-1.39",
      "testing-library": "static-1.155",
      "i18n-data": "static-1.225",
      "moment-timezone": "static-5.86",
      "jasmine": "static-4.4523",
      "signup-ui-url-generator": "static-2.8257",
      "HubStyle": "static-2.11981",
      "quartz-i18n": "static-1.969",
      "sassPrefix": "static-1.160",
      "bend-plugin-foundations-components": "static-1.4574",
      "floating-ui": "static-1.60",
      "foundations-theming-specialty": "static-1.2354",
      "hs-story-utils": "static-1.9625",
      "react-create-root-preference": "static-1.49",
      "react-virtualized": "static-2.102",
      "tanstack-table": "static-1.58",
      "trellis-assets": "static-1.2328",
      "ui-fonts": "static-1.936",
      "hs-locale-management": "static-1.220",
      "csstype": "static-1.50",
      "quartz-head": "static-1.959",
      "quick-fetch": "static-1.4057",
      "web-vitals": "static-1.9",
      "quartz-routing": "static-1.724",
      "usage-tracker-anonymous": "static-1.5967",
      "bender-build-tools": "static-1.3321",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.857",
      "hubspotter-http": "static-1.4790",
      "mobile-manifest-mixins": "static-1.554",
      "module-federation": "static-1.29",
      "quartz-auth": "static-1.969",
      "quartz-test": "static-1.969",
      "quartz-tracking": "static-1.673",
      "trellis-components": "static-1.2347",
      "usage-tracker-container": "static-1.7540",
      "bend-plugin-foundations-theming": "static-1.3121",
      "foundations-theming-base": "static-1.3623",
      "stylex": "static-1.37",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4853",
      "customer-data-ui-utilities": "static-1.10025",
      "FileManagerCore": "static-1.39705",
      "FileManagerLib": "static-1.39846",
      "hubspot-apollo-client": "static-1.5077",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.529",
      "timezone-utils": "static-2.5444",
      "ui-gdpr-components": "static-1.10550",
      "ts-schema": "static-1.4219",
      "ai-components-ui-library": "static-1.9459",
      "avatar-components": "static-1.2697",
      "content-assistance-lib": "static-1.8055",
      "crm-component-utils": "static-1.39624",
      "crm-display-components": "static-1.25374",
      "crm-fe-perf": "static-1.23101",
      "crm-links": "static-1.6516",
      "crm-message-bus": "static-1.43539",
      "crm-search-service-types": "static-1.1355",
      "crm-source-interpretation-lib": "static-1.5533",
      "customer-data-communicator": "static-1.46095",
      "customer-data-filters-ui": "static-1.40557",
      "customer-data-objects-ui-components": "static-1.13231",
      "customer-data-properties": "static-1.52260",
      "customer-data-rte": "static-1.33475",
      "draft-plugins": "static-2.22016",
      "file-manager-components": "static-1.24206",
      "framework-data-schema-resolvers": "static-1.7094",
      "frontend-preferences-client": "static-1.8126",
      "hubspot-prosemirror": "static-1.18799",
      "object-comments-thread-lib": "static-1.11165",
      "prosemirror-user-and-team-at-mentions": "static-1.1031",
      "reference-resolvers-lite": "static-1.8296",
      "trellis-theming": "static-1.1151",
      "ui-addon-upgrades": "static-9.18256",
      "universal-associations-select": "static-1.11267",
      "universal-record-utils-lib": "static-1.1536",
      "wootric-nps": "static-1.7121",
      "inbound-db-properties-service-client": "static-1.3984",
      "property-translator": "static-1.5594",
      "segments-query-core": "static-1.1621",
      "bend-plugin-chirp-manifest": "static-1.268",
      "chirp-fetch": "static-1.2087",
      "hub-http-shared-msw-handlers": "static-1.10440",
      "hubspotter-http-shared-msw-handlers": "static-1.10438",
      "usage-tracker-session-replay": "static-1.5236",
      "base-ui": "static-1.17",
      "react-day-picker": "static-1.6",
      "tanstack-virtual": "static-1.33",
      "react-dnd-compat": "static-1.4814",
      "audio-components": "static-1.6206",
      "ContentUtils": "static-1.68942",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29658",
      "FileManagerImages": "static-1.37357",
      "foundations-components-legacy": "static-1.1330",
      "html-to-image": "static-1.57",
      "immerable": "static-1.4347",
      "react-colorpicker": "static-2.10409",
      "ui-universal-auth": "static-1.9217",
      "video-components": "static-1.13918",
      "video-data-lib": "static-1.35574",
      "video-embed": "static-1.36408",
      "hubspot-apollo-cache": "static-1.536",
      "chatspot-core": "static-1.22315",
      "copilot-toolkit": "static-1.11646",
      "superstore": "static-1.4958",
      "ui-addon-video-player": "static-1.8906",
      "ui-coaching-tips": "static-1.29112",
      "card-properties-lib": "static-1.44793",
      "commerce-subscription-lib": "static-1.37591",
      "crm-actions": "static-1.6549",
      "crm-cards-sdk": "static-1.44211",
      "customer-data-properties-shared-msw-handlers": "static-1.9767",
      "customer-data-property-utils": "static-1.8296",
      "customer-data-tracking": "static-1.7084",
      "hs-resources": "static-1.379",
      "inbound-db-meta-service-client": "static-1.3718",
      "pulse": "static-1.815",
      "framework-data-table": "static-2.12357",
      "location-customization-utils-lib": "static-1.9862",
      "restore-request-side-panel-lib": "static-1.1402",
      "calling-error-reporting": "static-1.31521",
      "calling-internal-common": "static-1.31514",
      "calling-usage-tracker": "static-1.6740",
      "crm_data": "static-4.92602",
      "customer-data-content": "static-1.27658",
      "draft-content-plugins": "static-1.28741",
      "draft-convert": "static-2.76",
      "draft-extend": "static-3.79",
      "draft-js": "static-5.81",
      "draft-signature-plugin": "static-1.24545",
      "EmailSignatureEditor": "static-1.24824",
      "hubspot-prosemirror-plugins": "static-1.18791",
      "integration-settings-components": "static-1.16016",
      "integrations-lib": "static-1.16778",
      "integrations-tracking-lib": "static-1.5807",
      "native-integrations-shared-strings": "static-1.7978",
      "nav-meta": "static-1.30220",
      "onboarding-scopes": "static-1.6658",
      "outreach-assistant-email-generation": "static-1.6649",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12106",
      "quotes-client-types": "static-1.38722",
      "reference-resolvers": "static-1.8376",
      "rich-text-lib": "static-1.20168",
      "sales-email-signature-service-client": "static-1.4043",
      "sequences-lib": "static-1.8383",
      "ui-addon-i18n": "static-1.11346",
      "ui-addon-iframeable": "static-1.9275",
      "ui-business-units-lib": "static-1.9280",
      "ui-shepherd-react": "static-3.10461",
      "user-context": "static-1.5311",
      "whatsapp-sending-lib": "static-1.6456",
      "customer-data-filters-ui-msw-helpers": "static-1.22992",
      "customer-data-reference-ui-components": "static-1.13376",
      "events-data-lib": "static-1.438",
      "FormUrlGenerator": "static-2.4923",
      "framework-builder-read-service-client": "static-1.4145",
      "framework-data-schema-quick-fetch": "static-1.6999",
      "multi-account-reference-resolvers": "static-1.1182",
      "onboarding-tours": "static-1.16967",
      "reporting-datasets-permissions-lib": "static-1.14248",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21799",
      "batch-promise": "static-1.1744",
      "calling-global-api": "static-1.65181",
      "calling-lifecycle-internal": "static-1.66563",
      "calling-lifecycle-messages": "static-1.58857",
      "commerce-products-lib": "static-1.10275",
      "conditional-properties-service-client": "static-1.3936",
      "crm-index-visualization-core": "static-1.4399",
      "crm-pipelines-api-client-types": "static-1.4277",
      "external-options-client-types": "static-1.4265",
      "formula-editor": "static-1.14602",
      "google-libphonenumber": "static-1.41",
      "inbounddb-objects-service-types": "static-1.4355",
      "meetings-icalendar-utils-lib": "static-1.831",
      "multi-currency-client-types": "static-1.3830",
      "object-builder-ui-client": "static-1.49393",
      "pipeline-validation-client-types": "static-1.4105",
      "property-value-citations": "static-1.2874",
      "smart-property-lib": "static-1.8089",
      "tiered-pricing": "static-1.1767",
      "topics-actions-lib": "static-1.354",
      "ui-addon-form-validation": "static-1.11189",
      "zustand": "static-1.79",
      "breeze-engine-lib": "static-1.1422",
      "video-components-external": "static-1.11916",
      "fdsr-migration-layer": "static-1.213",
      "persist-promise": "static-1.3901",
      "content-media-capture": "static-1.5146",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25959",
      "knowledge-content-types": "static-1.8591",
      "payment-link-components": "static-1.23972",
      "ui-addon-emoji-picker": "static-1.10085",
      "call-summary": "static-1.39871",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10586",
      "laboratory-lib": "static-3.7351",
      "merchandise-lib": "static-1.269",
      "purchase-motions-components": "static-1.6207",
      "crm-object-search-query-utilities": "static-1.10016",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "cms-field-types": "static-1.5015",
      "content-icons-ui": "static-1.2285",
      "underscore": "static-1.8",
      "unified-auth-core-lib": "static-1.1013",
      "social-insights-client-types": "static-1.22589",
      "outpost": "static-1.4366",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5692",
      "magpie-types": "static-1.5152",
      "simple-logging-lib": "static-1.3249",
      "growth-onboarding-feedback-components": "static-1.6780",
      "customer-data-sidebar": "static-2.46549",
      "enrichment-properties-lib": "static-1.17500",
      "ui-addon-draggable-compat": "static-2.4458",
      "commerce-billing-lib": "static-1.19762",
      "commerce-shared-components-lib": "static-1.19028",
      "commerce-tools-ui-lib": "static-1.10870",
      "event-emitter": "static-1.1150",
      "bend-plugin-pulse": "static-1.318",
      "fast-json-patch": "static-1.66",
      "customer-data-associations": "static-1.7532",
      "reporting-data": "static-1.68340",
      "ui-addon-draggable": "static-3.4956",
      "crm-record-cards-service-types": "static-1.3723",
      "crm_universal": "static-1.22355",
      "SalesContentIndexUI": "static-3.9514",
      "content-embed-lib": "static-1.7537",
      "data-model-builder-lib": "static-1.12910",
      "remote-ui": "static-1.68",
      "ui-components-test-utils": "static-1.5811",
      "ui-extensions-remote-renderer": "static-1.17603",
      "universal-page-editor-lib": "static-1.3210",
      "integrations-error-boundary-lib": "static-1.14193",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10564",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.731",
      "messaging-types-lib": "static-1.46659",
      "ai-addon-copilot-preview": "static-1.8671",
      "copilot-plugins": "static-1.11618",
      "data-token-picker": "static-1.16748",
      "sequences-client-types-lib": "static-1.8240",
      "foundations-components-test-utils": "static-1.5788",
      "navigation-messaging": "static-1.7910",
      "getting-started-shared-tasks": "static-1.18992",
      "getting-started-shared-tasks-store": "static-1.18110",
      "onboarding-tours-utils": "static-1.1033",
      "messaging-usage-based-billing-components-lib": "static-1.1784",
      "whatsapp-management-lib": "static-1.9615",
      "growth-data-modal": "static-1.5749",
      "growth-onboarding-confetti": "static-1.3261",
      "growth-onboarding-next-action-utils": "static-1.2492",
      "navigation-components": "static-1.18583",
      "onboarding-tours-client": "static-1.5181",
      "ui-shepherd-tracker": "static-1.7842",
      "shared-worker-versioning": "static-1.11237",
      "voice-sms-access-library": "static-1.1716",
      "commerce-permissions": "static-1.976",
      "products-iframe-lib": "static-1.8400",
      "products-ui-components-shared-msw-handlers": "static-1.10822",
      "crm-index-associations-lib": "static-1.6641",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10523",
      "sales-views-client-types": "static-1.4457",
      "bark-lib": "static-1.16694",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.98",
      "crm-properties-common-lib": "static-1.6087",
      "react-codemirror": "static-1.10839",
      "data-agent-kit": "static-1.504",
      "fsm": "static-1.3931",
      "policy-lib": "static-1.6987",
      "react-tinymce": "static-1.55769",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54895",
      "tinymce-plugins": "static-1.58009",
      "tinymce-themes": "static-1.56865",
      "breeze-engine-core": "static-1.700",
      "highlight.js": "static-1.82",
      "content-media-composition-data-lib": "static-1.12950",
      "content-media-compositions": "static-2.16957",
      "idb-keyval": "static-1.47",
      "media-bridge-lib": "static-1.19266",
      "fix-webm-duration": "static-1.26",
      "notification-sounds": "static-1.4625",
      "seat-types-lib": "static-1.457",
      "ui-addon-opt": "static-4.8560",
      "commerce-tours-lib": "static-1.6464",
      "growth-onboarding-reliability": "static-1.5282",
      "sales-checkout-service-client": "static-1.3743",
      "calling-cross-tab-library": "static-1.19488",
      "calling-lifecycle-usage-tracker": "static-1.9217",
      "purchase-motions-api": "static-1.6210",
      "reactive-lib": "static-1.922",
      "card-payment-highlight-lib": "static-1.37762",
      "card-subscription-highlight-lib": "static-1.40014",
      "commerce-contract-lib": "static-1.12965",
      "invoices-highlight-card-lib": "static-1.55386",
      "orders-highlight-card-lib": "static-1.22003",
      "products-highlight-card-lib": "static-1.18558",
      "quotes-highlight-card-lib": "static-1.72632",
      "usage-based-billing-components-lib": "static-1.9817",
      "utility-belt": "static-1.2731",
      "payments-enrollment-embed-lib": "static-1.23588",
      "stripe-embedded-components": "static-1.7854",
      "growth-onboarding-empty-states": "static-1.6115",
      "InboxConnectUtils": "static-4.15351",
      "payments-post-enroll-local-storage-lib": "static-1.5304",
      "qrcode-generator": "static-1.72",
      "reporting-client-types": "static-1.2623",
      "react-flip-move": "static-1.74",
      "FireAlarmUi": "static-1.4647",
      "sales-templates-service-types-lib": "static-1.4307",
      "ui-asset-management-lib": "static-1.11285",
      "association-settings-lib": "static-1.10818",
      "collaboration-sidebar": "static-1.58482",
      "conditional-property-settings-modal": "static-1.12872",
      "data-model-commons-lib": "static-1.13181",
      "ExportDialog": "static-6.10579",
      "final-form": "static-1.73",
      "nudge-client-utils": "static-1.2989",
      "object-definition-builder-lib": "static-1.7305",
      "property-management-iframe": "static-1.13820",
      "property-usages-lib": "static-1.5655",
      "reactflow": "static-1.67",
      "simple-data-table": "static-1.3339",
      "used-in-list-lib": "static-1.7160",
      "visual-association": "static-1.6091",
      "highcharts": "static-8.107",
      "reporting-visualizations": "static-1.60416",
      "ui-extensibility-client-types": "static-1.4123",
      "adobe-sign-auth-lib": "static-1.246",
      "ads-unified-auth-lib": "static-1.763",
      "google-sheets-integration-lib": "static-1.823",
      "microsoft-drive-integration-lib": "static-1.929",
      "surveymonkey-integration-lib": "static-1.268",
      "slack-ui-library": "static-1.10598",
      "automation-platform-service-types": "static-1.2639",
      "ContentData": "static-1.69017",
      "email-portal-health-service-types": "static-1.1177",
      "marketing-email-service-types": "static-1.2043",
      "ai-rendering-library": "static-1.10879",
      "ai-settings-ui-library": "static-1.8188",
      "ui-brand-identity-lib": "static-1.16012",
      "messaging-shared-utils-lib": "static-1.1233",
      "messaging-user-info-utils-lib": "static-1.1403",
      "content-whatsapp-service-types": "static-1.504",
      "marketing-platform-lib": "static-1.7067",
      "short-messages-app-service-client": "static-1.4118",
      "ui-tool-access": "static-1.10353",
      "onboarding-data-sync-lib": "static-1.2310",
      "growth-onboarding-next-action-components": "static-1.2520",
      "user-context-client": "static-1.4751",
      "nest": "static-1.435",
      "calling-orchestration-schema": "static-1.36493",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16147",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4707",
      "storybook-react": "static-1.36",
      "hub-http-contrib": "static-1.3241",
      "interframe": "static-3.4955",
      "tinymce-data": "static-1.40980",
      "ui-addon-sales-email": "static-1.5412",
      "layout-dnd-components": "static-1.12819",
      "layout-dnd-utils": "static-1.11794",
      "NamespacedHubStyle": "static-2.9189",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40793",
      "accounting-integrations-ui-components": "static-1.7394",
      "invoices-ui-lib": "static-1.55402",
      "commerce-products-api": "static-1.2581",
      "invoices-iframe-lib": "static-1.57460",
      "quotes-modal-lib": "static-1.103310",
      "quotes-ui-lib": "static-1.81353",
      "platform-infra-nav-components": "static-1.7812",
      "reporting-ui-components": "static-2.65611",
      "subscription-experience-data-types": "static-1.15151",
      "marketplace-ui-apps-core": "static-1.18934",
      "stripe-connect-js": "static-1.73",
      "ui-addon-react-router-dom": "static-1.9733",
      "nested-table": "static-1.437",
      "chatspot-widget-iframe": "static-1.22306",
      "collaboration-sidebar-common": "static-1.3279",
      "nudge-custom-function-registry": "static-1.2746",
      "nudge-renderer-utils": "static-1.3065",
      "whisper-core-api": "static-1.7113",
      "property-management-common": "static-1.6108",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15447",
      "advanced-menus-lib": "static-1.12341",
      "ui-memberships-settings-lib": "static-1.34600",
      "breeze-onboarding-components": "static-1.505",
      "embedded-academy-lib": "static-1.15083",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.41804",
      "reporting-snowflake": "static-1.56958",
      "upgrade-components-lib": "static-1.398",
      "meetings-connect-utils-lib": "static-1.7805",
      "layout-data-lib": "static-1.10119",
      "commerce-tax-lib": "static-1.737",
      "price-books-api": "static-1.1503",
      "price-books-components": "static-1.1561",
      "property-description-translator": "static-1.4038",
      "ramp-editor": "static-1.701",
      "commerce-analytics-service-client": "static-1.3731",
      "totals-ui-components": "static-1.24115",
      "reporting-plugins": "static-1.10647",
      "reporting-reports": "static-1.68018",
      "edison-service-client-types": "static-1.586",
      "developer-experience-shared-components": "static-1.10707",
      "marketplace-ui-client-types": "static-1.17809",
      "marketplace-ui-common": "static-1.20402",
      "ui-addon-integrations-directory-panel": "static-2.8222",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.374",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15446",
      "simple-menus-lib": "static-1.16963",
      "onboarding-journeys-lib": "static-1.615",
      "academy-common-lib": "static-1.14543",
      "dashboard-lib": "static-1.82319",
      "share-with-third-party-component-lib": "static-1.8904",
      "line-items-api": "static-1.978",
      "commerce-totals-service-types": "static-1.3954",
      "campaign-roi-lib": "static-1.9823",
      "ui-addon-calendars": "static-2.5523",
      "apps-service-types": "static-1.3973",
      "oauth-service-types": "static-1.4453",
      "ui-product-approvals-common": "static-1.775",
      "academy-service-client": "static-1.3887",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4605",
      "trellis-ecosystem": "static-1.7483",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30094",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4919",
      "atom": "/atom/static-1.5276",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9087",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16182",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13253",
      "conversations-message-history": "/conversations-message-history/static-1.13312",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10701",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.23457",
      "data-fetching-client": "/data-fetching-client/static-1.9857",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5792",
      "hs-test-utils": "/hs-test-utils/static-1.8223",
      "hubspot-dlb": "/hubspot-dlb/static-2.1854",
      "HubStyleTokens": "/HubStyleTokens/static-2.11674",
      "I18n": "/I18n/static-7.1649",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.3221",
      "jasmine-runner": "/jasmine-runner/static-1.6654",
      "quartz": "/quartz/static-1.7294",
      "react-dlb": "/react-dlb/static-1.83",
      "react-select-plus": "/react-select-plus/static-1.108",
      "react-transition-group": "/react-transition-group/static-2.68",
      "redux-thunk": "/redux-thunk/static-2.43",
      "reselect": "/reselect/static-3.8",
      "sanitize": "/sanitize/static-1.4677",
      "StyleGuideUI": "/StyleGuideUI/static-3.491",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4732",
      "usage-tracker": "/usage-tracker/static-1.7550",
      "usage-tracker-core": "/usage-tracker-core/static-1.7400",
      "usage-tracker-public": "/usage-tracker-public/static-1.7361",
      "viral-links-lib": "/viral-links-lib/static-1.7270",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6342",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5015",
      "conversations-prop-types": "/conversations-prop-types/static-1.7653",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22194",
      "cssUtils": "/cssUtils/static-1.849",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.354",
      "foundations-components": "/foundations-components/static-1.8305",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6417",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
      "immutable": "/immutable/static-2.79",
      "metrics-js": "/metrics-js/static-1.9637",
      "PatternValidationJS": "/PatternValidationJS/static-1-add-latest-to-version-tag.2",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.189",
      "react-aria": "/react-aria/static-1.69",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.71",
      "react-rhumb": "/react-rhumb/static-1.16903",
      "react-utils": "/react-utils/static-2.5480",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "sanitize-text": "/sanitize-text/static-1.8346",
      "signup-constants": "/signup-constants/static-1.19367",
      "styled-components": "/styled-components/static-2.89",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5964",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6153",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3538",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.1072",
      "quartz-core": "/quartz-core/static-1.6513",
      "foundations-assets": "/foundations-assets/static-1.5075",
      "foundations-theming": "/foundations-theming/static-1.4638",
      "UIComponents": "/UIComponents/static-3.8620",
      "conversations-async-data": "/conversations-async-data/static-2.7866",
      "customer-data-email": "/customer-data-email/static-1.18386",
      "cv-backend-services": "/cv-backend-services/static-1.1589",
      "immutable-less": "/immutable-less/static-1.4850",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7447",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33775",
      "customer-data-objects": "/customer-data-objects/static-1.7880",
      "icons": "/icons/static-2.667",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.756",
      "rpc-client-utils": "/rpc-client-utils/static-1.4858",
      "ui-images": "/ui-images/static-2.1211",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.85",
      "HeadJS": "/HeadJS/static-2.780",
      "framer-motion": "/framer-motion/static-1.75",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3334",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.155",
      "i18n-data": "/i18n-data/static-1.225",
      "moment-timezone": "/moment-timezone/static-5.86",
      "jasmine": "/jasmine/static-4.4523",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8257",
      "HubStyle": "/HubStyle/static-2.11981",
      "quartz-i18n": "/quartz-i18n/static-1.969",
      "sassPrefix": "/sassPrefix/static-1.160",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4574",
      "floating-ui": "/floating-ui/static-1.60",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2354",
      "hs-story-utils": "/hs-story-utils/static-1.9625",
      "react-create-root-preference": "/react-create-root-preference/static-1.49",
      "react-virtualized": "/react-virtualized/static-2.102",
      "tanstack-table": "/tanstack-table/static-1.58",
      "trellis-assets": "/trellis-assets/static-1.2328",
      "ui-fonts": "/ui-fonts/static-1.936",
      "hs-locale-management": "/hs-locale-management/static-1.220",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.959",
      "quick-fetch": "/quick-fetch/static-1.4057",
      "web-vitals": "/web-vitals/static-1.9",
      "quartz-routing": "/quartz-routing/static-1.724",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5967",
      "bender-build-tools": "/bender-build-tools/static-1.3321",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.857",
      "hubspotter-http": "/hubspotter-http/static-1.4790",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.554",
      "module-federation": "/module-federation/static-1.29",
      "quartz-auth": "/quartz-auth/static-1.969",
      "quartz-test": "/quartz-test/static-1.969",
      "quartz-tracking": "/quartz-tracking/static-1.673",
      "trellis-components": "/trellis-components/static-1.2347",
      "usage-tracker-container": "/usage-tracker-container/static-1.7540",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3121",
      "foundations-theming-base": "/foundations-theming-base/static-1.3623",
      "stylex": "/stylex/static-1.37",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4853",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10025",
      "FileManagerCore": "/FileManagerCore/static-1.39705",
      "FileManagerLib": "/FileManagerLib/static-1.39846",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5077",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.529",
      "timezone-utils": "/timezone-utils/static-2.5444",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10550",
      "ts-schema": "/ts-schema/static-1.4219",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9459",
      "avatar-components": "/avatar-components/static-1.2697",
      "content-assistance-lib": "/content-assistance-lib/static-1.8055",
      "crm-component-utils": "/crm-component-utils/static-1.39624",
      "crm-display-components": "/crm-display-components/static-1.25374",
      "crm-fe-perf": "/crm-fe-perf/static-1.23101",
      "crm-links": "/crm-links/static-1.6516",
      "crm-message-bus": "/crm-message-bus/static-1.43539",
      "crm-search-service-types": "/crm-search-service-types/static-1.1355",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5533",
      "customer-data-communicator": "/customer-data-communicator/static-1.46095",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40557",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13231",
      "customer-data-properties": "/customer-data-properties/static-1.52260",
      "customer-data-rte": "/customer-data-rte/static-1.33475",
      "draft-plugins": "/draft-plugins/static-2.22016",
      "file-manager-components": "/file-manager-components/static-1.24206",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7094",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8126",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18799",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11165",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1031",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8296",
      "trellis-theming": "/trellis-theming/static-1.1151",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18256",
      "universal-associations-select": "/universal-associations-select/static-1.11267",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1536",
      "wootric-nps": "/wootric-nps/static-1.7121",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3984",
      "property-translator": "/property-translator/static-1.5594",
      "segments-query-core": "/segments-query-core/static-1.1621",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.268",
      "chirp-fetch": "/chirp-fetch/static-1.2087",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10440",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10438",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5236",
      "base-ui": "/base-ui/static-1.17",
      "react-day-picker": "/react-day-picker/static-1.6",
      "tanstack-virtual": "/tanstack-virtual/static-1.33",
      "react-dnd-compat": "/react-dnd-compat/static-1.4814",
      "audio-components": "/audio-components/static-1.6206",
      "ContentUtils": "/ContentUtils/static-1.68942",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29658",
      "FileManagerImages": "/FileManagerImages/static-1.37357",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1330",
      "html-to-image": "/html-to-image/static-1.57",
      "immerable": "/immerable/static-1.4347",
      "react-colorpicker": "/react-colorpicker/static-2.10409",
      "ui-universal-auth": "/ui-universal-auth/static-1.9217",
      "video-components": "/video-components/static-1.13918",
      "video-data-lib": "/video-data-lib/static-1.35574",
      "video-embed": "/video-embed/static-1.36408",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.536",
      "chatspot-core": "/chatspot-core/static-1.22315",
      "copilot-toolkit": "/copilot-toolkit/static-1.11646",
      "superstore": "/superstore/static-1.4958",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8906",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29112",
      "card-properties-lib": "/card-properties-lib/static-1.44793",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37591",
      "crm-actions": "/crm-actions/static-1.6549",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44211",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9767",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8296",
      "customer-data-tracking": "/customer-data-tracking/static-1.7084",
      "hs-resources": "/hs-resources/static-1.379",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "pulse": "/pulse/static-1.815",
      "framework-data-table": "/framework-data-table/static-2.12357",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9862",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1402",
      "calling-error-reporting": "/calling-error-reporting/static-1.31521",
      "calling-internal-common": "/calling-internal-common/static-1.31514",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6740",
      "crm_data": "/crm_data/static-4.92602",
      "customer-data-content": "/customer-data-content/static-1.27658",
      "draft-content-plugins": "/draft-content-plugins/static-1.28741",
      "draft-convert": "/draft-convert/static-2.76",
      "draft-extend": "/draft-extend/static-3.79",
      "draft-js": "/draft-js/static-5.81",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24545",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24824",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18791",
      "integration-settings-components": "/integration-settings-components/static-1.16016",
      "integrations-lib": "/integrations-lib/static-1.16778",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5807",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7978",
      "nav-meta": "/nav-meta/static-1.30220",
      "onboarding-scopes": "/onboarding-scopes/static-1.6658",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6649",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12106",
      "quotes-client-types": "/quotes-client-types/static-1.38722",
      "reference-resolvers": "/reference-resolvers/static-1.8376",
      "rich-text-lib": "/rich-text-lib/static-1.20168",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4043",
      "sequences-lib": "/sequences-lib/static-1.8383",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11346",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9275",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9280",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10461",
      "user-context": "/user-context/static-1.5311",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6456",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22992",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13376",
      "events-data-lib": "/events-data-lib/static-1.438",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4923",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4145",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6999",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1182",
      "onboarding-tours": "/onboarding-tours/static-1.16967",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14248",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21799",
      "batch-promise": "/batch-promise/static-1.1744",
      "calling-global-api": "/calling-global-api/static-1.65181",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66563",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58857",
      "commerce-products-lib": "/commerce-products-lib/static-1.10275",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3936",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4399",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4277",
      "external-options-client-types": "/external-options-client-types/static-1.4265",
      "formula-editor": "/formula-editor/static-1.14602",
      "google-libphonenumber": "/google-libphonenumber/static-1.41",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4355",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.831",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3830",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49393",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4105",
      "property-value-citations": "/property-value-citations/static-1.2874",
      "smart-property-lib": "/smart-property-lib/static-1.8089",
      "tiered-pricing": "/tiered-pricing/static-1.1767",
      "topics-actions-lib": "/topics-actions-lib/static-1.354",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11189",
      "zustand": "/zustand/static-1.79",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1422",
      "video-components-external": "/video-components-external/static-1.11916",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.213",
      "persist-promise": "/persist-promise/static-1.3901",
      "content-media-capture": "/content-media-capture/static-1.5146",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25959",
      "knowledge-content-types": "/knowledge-content-types/static-1.8591",
      "payment-link-components": "/payment-link-components/static-1.23972",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10085",
      "call-summary": "/call-summary/static-1.39871",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10586",
      "laboratory-lib": "/laboratory-lib/static-3.7351",
      "merchandise-lib": "/merchandise-lib/static-1.269",
      "purchase-motions-components": "/purchase-motions-components/static-1.6207",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10016",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "cms-field-types": "/cms-field-types/static-1.5015",
      "content-icons-ui": "/content-icons-ui/static-1.2285",
      "underscore": "/underscore/static-1.8",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1013",
      "social-insights-client-types": "/social-insights-client-types/static-1.22589",
      "outpost": "/outpost/static-1.4366",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5692",
      "magpie-types": "/magpie-types/static-1.5152",
      "simple-logging-lib": "/simple-logging-lib/static-1.3249",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6780",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46549",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17500",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4458",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.19762",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19028",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10870",
      "event-emitter": "/event-emitter/static-1.1150",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.318",
      "fast-json-patch": "/fast-json-patch/static-1.66",
      "customer-data-associations": "/customer-data-associations/static-1.7532",
      "reporting-data": "/reporting-data/static-1.68340",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4956",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3723",
      "crm_universal": "/crm_universal/static-1.22355",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9514",
      "content-embed-lib": "/content-embed-lib/static-1.7537",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12910",
      "remote-ui": "/remote-ui/static-1.68",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5811",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17603",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3210",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14193",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10564",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.731",
      "messaging-types-lib": "/messaging-types-lib/static-1.46659",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8671",
      "copilot-plugins": "/copilot-plugins/static-1.11618",
      "data-token-picker": "/data-token-picker/static-1.16748",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8240",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5788",
      "navigation-messaging": "/navigation-messaging/static-1.7910",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18992",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18110",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1033",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1784",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.9615",
      "growth-data-modal": "/growth-data-modal/static-1.5749",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3261",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2492",
      "navigation-components": "/navigation-components/static-1.18583",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5181",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7842",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11237",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1716",
      "commerce-permissions": "/commerce-permissions/static-1.976",
      "products-iframe-lib": "/products-iframe-lib/static-1.8400",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10822",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6641",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10523",
      "sales-views-client-types": "/sales-views-client-types/static-1.4457",
      "bark-lib": "/bark-lib/static-1.16694",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.98",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6087",
      "react-codemirror": "/react-codemirror/static-1.10839",
      "data-agent-kit": "/data-agent-kit/static-1.504",
      "fsm": "/fsm/static-1.3931",
      "policy-lib": "/policy-lib/static-1.6987",
      "react-tinymce": "/react-tinymce/static-1.55769",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54895",
      "tinymce-plugins": "/tinymce-plugins/static-1.58009",
      "tinymce-themes": "/tinymce-themes/static-1.56865",
      "breeze-engine-core": "/breeze-engine-core/static-1.700",
      "highlight.js": "/highlight.js/static-1.82",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12950",
      "content-media-compositions": "/content-media-compositions/static-2.16957",
      "idb-keyval": "/idb-keyval/static-1.47",
      "media-bridge-lib": "/media-bridge-lib/static-1.19266",
      "fix-webm-duration": "/fix-webm-duration/static-1.26",
      "notification-sounds": "/notification-sounds/static-1.4625",
      "seat-types-lib": "/seat-types-lib/static-1.457",
      "ui-addon-opt": "/ui-addon-opt/static-4.8560",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6464",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5282",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19488",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9217",
      "purchase-motions-api": "/purchase-motions-api/static-1.6210",
      "reactive-lib": "/reactive-lib/static-1.922",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37762",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40014",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.12965",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55386",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22003",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18558",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72632",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9817",
      "utility-belt": "/utility-belt/static-1.2731",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23588",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7854",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6115",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15351",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5304",
      "qrcode-generator": "/qrcode-generator/static-1.72",
      "reporting-client-types": "/reporting-client-types/static-1.2623",
      "react-flip-move": "/react-flip-move/static-1.74",
      "FireAlarmUi": "/FireAlarmUi/static-1.4647",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4307",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11285",
      "association-settings-lib": "/association-settings-lib/static-1.10818",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58482",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12872",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13181",
      "ExportDialog": "/ExportDialog/static-6.10579",
      "final-form": "/final-form/static-1.73",
      "nudge-client-utils": "/nudge-client-utils/static-1.2989",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7305",
      "property-management-iframe": "/property-management-iframe/static-1.13820",
      "property-usages-lib": "/property-usages-lib/static-1.5655",
      "reactflow": "/reactflow/static-1.67",
      "simple-data-table": "/simple-data-table/static-1.3339",
      "used-in-list-lib": "/used-in-list-lib/static-1.7160",
      "visual-association": "/visual-association/static-1.6091",
      "highcharts": "/highcharts/static-8.107",
      "reporting-visualizations": "/reporting-visualizations/static-1.60416",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4123",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.246",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.763",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.823",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.929",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.268",
      "slack-ui-library": "/slack-ui-library/static-1.10598",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2639",
      "ContentData": "/ContentData/static-1.69017",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1177",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.2043",
      "ai-rendering-library": "/ai-rendering-library/static-1.10879",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8188",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16012",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1233",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1403",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.504",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7067",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4118",
      "ui-tool-access": "/ui-tool-access/static-1.10353",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2310",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2520",
      "user-context-client": "/user-context-client/static-1.4751",
      "nest": "/nest/static-1.435",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36493",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16147",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4707",
      "storybook-react": "/storybook-react/static-1.36",
      "hub-http-contrib": "/hub-http-contrib/static-1.3241",
      "interframe": "/interframe/static-3.4955",
      "tinymce-data": "/tinymce-data/static-1.40980",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5412",
      "layout-dnd-components": "/layout-dnd-components/static-1.12819",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11794",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9189",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40793",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7394",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55402",
      "commerce-products-api": "/commerce-products-api/static-1.2581",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57460",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103310",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81353",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7812",
      "reporting-ui-components": "/reporting-ui-components/static-2.65611",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15151",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18934",
      "stripe-connect-js": "/stripe-connect-js/static-1.73",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9733",
      "nested-table": "/nested-table/static-1.437",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22306",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3279",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2746",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3065",
      "whisper-core-api": "/whisper-core-api/static-1.7113",
      "property-management-common": "/property-management-common/static-1.6108",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15447",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12341",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34600",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.505",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15083",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.41804",
      "reporting-snowflake": "/reporting-snowflake/static-1.56958",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.398",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7805",
      "layout-data-lib": "/layout-data-lib/static-1.10119",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.737",
      "price-books-api": "/price-books-api/static-1.1503",
      "price-books-components": "/price-books-components/static-1.1561",
      "property-description-translator": "/property-description-translator/static-1.4038",
      "ramp-editor": "/ramp-editor/static-1.701",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3731",
      "totals-ui-components": "/totals-ui-components/static-1.24115",
      "reporting-plugins": "/reporting-plugins/static-1.10647",
      "reporting-reports": "/reporting-reports/static-1.68018",
      "edison-service-client-types": "/edison-service-client-types/static-1.586",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10707",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17809",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20402",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8222",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.374",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15446",
      "simple-menus-lib": "/simple-menus-lib/static-1.16963",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.615",
      "academy-common-lib": "/academy-common-lib/static-1.14543",
      "dashboard-lib": "/dashboard-lib/static-1.82319",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8904",
      "line-items-api": "/line-items-api/static-1.978",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3954",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9823",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5523",
      "apps-service-types": "/apps-service-types/static-1.3973",
      "oauth-service-types": "/oauth-service-types/static-1.4453",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.775",
      "academy-service-client": "/academy-service-client/static-1.3887",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4605",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7483",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30094",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};